/*
 * File: Select.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on June 20, 2022 at 1:18 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: July 6, 2024 at 12:45 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	position: relative;
	z-index: 999;

	& > label {
		cursor: pointer;
		text-align: left;
	 	color: ${({ theme, error }) => (error ? theme.statusDangerBase : theme.secondaryText)};
	}
`;

export const IconWrapper = styled.div`
	position: absolute;
	right: 2rem;
	display: flex;
	height: 100%;
	justify-content: center;
	align-items: center;
	padding: 0 0.75rem;

	svg {
		color: ${({ theme }) => theme.inputPlaceholder};

		&:hover {
			opacity: 0.8;
		}
	}
`;

export const FloatingWrapper = styled.div`
	position: absolute;
	bottom: -20px;
	color: ${({ theme }) => theme.statusDangerBase};
	max-width: 100%;
	left: 0px;

	p {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		display: block !important;
		font-size: 0.6875rem !important;
	}
`;
